export default __webpack_public_path__ + "static/media/sub-admin-gold.09d4382d.svg";